/**
 * Debounce helper
 *
 * Delays function execution until no new calls occur within delay.
 */
export function debounce(func, delay = 500) {
  let timer = null;

  return (...args) => {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      func(...args);
    }, delay);
  };
}
